var InsertLinkModal = {
	urlLabel: "Link to",
	urlHelpText: "http:// is required for external links",
	titleLabel: "Link title",
	titleHelpText: "Used for accessibility and SEO",
	selectLabel: "Open this link in",
	internalOption: "the same window",
	externalOption: "a new window"
};
var _en = {
	InsertLinkModal: InsertLinkModal
};

export { InsertLinkModal, _en as default };
